export default __webpack_public_path__ + "static/media/AreaFriend.92652361.svg";